const NO_VALUE = '–';

export { NO_VALUE };
//# sourceMappingURL=noValue.mjs.map
